import React from "react";
import "./index.scss";

/**
 * @desc A primary button.
 */
export const Button = (props) => {
  const { className = "", ...rest } = props;

  return <button className={`btn btn-primary ${className}`} {...rest} />;
};
